import * as React from 'react';

import { PK } from 'common/types';
import { useMappedValues } from 'common/hooks';
import { RelationSelect, CollapsibleSection } from 'common/components';
import { RelationOption } from 'common/components/RelationSelect';
import { useBlogsList } from '../queries';
import { SaveStatusProps } from '../../../common/components/SaveStatus';
import { useMemo } from 'react';

type Props = {
  blog_pk?: PK;
  pk?: PK;
  onSave: (blogsPks: PK[]) => void;
  saveStatus: SaveStatusProps;
};

const BlogsPicker = ({ pk, blog_pk, saveStatus, onSave }: Props) => {
  const blogsList = useBlogsList();

  const options = useMappedValues(blogsList.data?.values, ({ pk, title }) => ({
    label: title,
    value: pk,
  }));

  const defaults = useMemo(() => {
    const pickedBlog = options.find((option) => option.value === blog_pk);

    return pickedBlog ? [pickedBlog] : [];
  }, [options, blog_pk]);

  const handleSave = (values: RelationOption[]) => {
    if (pk) {
      const blogsPks = values.map(({ value }) => value);
      onSave(blogsPks);
    }
  };

  return (
    <>
      <CollapsibleSection title="Add blog" saveStatus={saveStatus} disabled={!pk}>
        <RelationSelect
          onSave={handleSave}
          options={options}
          defaultValues={defaults}
          isLoading={blogsList.isLoading}
          // TODO: we won't show toast, the previous blog would be overwritten and the form will close immediately
          isMulti={false}
        />
      </CollapsibleSection>
    </>
  );
};

export default BlogsPicker;
